var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rupee",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 34.667,
    viewBox: "0 0 52 34.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M183.39,61.3a1.317,1.317,0,1,0,0-2.634H171.976a1.317,1.317,0,1,0,0,2.634h3.951a3.066,3.066,0,0,1,2.929,2.195h-6.88a1.317,1.317,0,0,0,0,2.634h6.466a3.069,3.069,0,0,1-2.514,1.317h-3.951a1.317,1.317,0,0,0-.743,2.406l9.658,6.585a1.318,1.318,0,0,0,1.486-2.178l-6.143-4.188a5.7,5.7,0,0,0,5.1-3.943h2.058a1.317,1.317,0,0,0,0-2.634h-1.846a5.661,5.661,0,0,0-.824-2.195Zm0,0",
    transform: "translate(-153.325 -50.71)",
    fill: "#003358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M46.042,0H5.958A5.963,5.963,0,0,0,0,5.958v22.75a5.963,5.963,0,0,0,5.958,5.958H46.042A5.963,5.963,0,0,0,52,28.708V5.958A5.963,5.963,0,0,0,46.042,0ZM48.75,28.708a2.712,2.712,0,0,1-2.708,2.708H5.958A2.712,2.712,0,0,1,3.25,28.708V5.958A2.712,2.712,0,0,1,5.958,3.25H46.042A2.712,2.712,0,0,1,48.75,5.958Zm0,0",
    fill: "#f6781b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.8b69a2704db33215a2265fca5fc7b021.svg";
export { ForwardRef as ReactComponent };